// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { WIZARD_STEPS, useWizard } from './WizardContext';
import { StepProgressBar } from './StepProgressBar';

/**
 * Relationship-creation wizard progress bar — a thin adapter around the
 * generic {@link StepProgressBar} that pulls the current step + per-step
 * validation from the relationship {@code WizardContext}. Other wizards
 * (e.g. Change of Agency) consume {@link StepProgressBar} directly with
 * their own steps list.
 */
export function WizardProgress() {
  const { state, validateStep, policiesStepEnabled } = useWizard();

  // Single-step wizard (Add Policies step off): a progress bar is meaningless.
  if (!policiesStepEnabled) {
    return null;
  }

  return (
    <StepProgressBar
      steps={WIZARD_STEPS.map((s) => ({ id: s.id, name: s.name }))}
      currentStep={state.currentStep}
      isStepCompleted={(step) => {
        const isCompleted = state.currentStep > step.id;
        return isCompleted && validateStep(step.id).isValid;
      }}
    />
  );
}
